import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ff341452 = () => interopDefault(import('../pages/aboutUs.vue' /* webpackChunkName: "pages/aboutUs" */))
const _235bca30 = () => interopDefault(import('../pages/brands.vue' /* webpackChunkName: "pages/brands" */))
const _7d581f72 = () => interopDefault(import('../pages/cc/index.vue' /* webpackChunkName: "pages/cc/index" */))
const _40a0086c = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _c55d451a = () => interopDefault(import('../pages/ds.vue' /* webpackChunkName: "pages/ds" */))
const _7faabe23 = () => interopDefault(import('../pages/favorites.vue' /* webpackChunkName: "pages/favorites" */))
const _085d660a = () => interopDefault(import('../pages/hermes.vue' /* webpackChunkName: "pages/hermes" */))
const _6d425811 = () => interopDefault(import('../pages/payments.vue' /* webpackChunkName: "pages/payments" */))
const _866aba2c = () => interopDefault(import('../pages/random/index.vue' /* webpackChunkName: "pages/random/index" */))
const _99e12a96 = () => interopDefault(import('../pages/search-results.vue' /* webpackChunkName: "pages/search-results" */))
const _6ff81766 = () => interopDefault(import('../pages/search-results-stage.vue' /* webpackChunkName: "pages/search-results-stage" */))
const _0154ad4d = () => interopDefault(import('../pages/shield.vue' /* webpackChunkName: "pages/shield" */))
const _5755355e = () => interopDefault(import('../pages/shippings.vue' /* webpackChunkName: "pages/shippings" */))
const _1ad10a62 = () => interopDefault(import('../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _59ce015a = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _f685b5d2 = () => interopDefault(import('../pages/track.vue' /* webpackChunkName: "pages/track" */))
const _cd335cdc = () => interopDefault(import('../pages/wizard/index.vue' /* webpackChunkName: "pages/wizard/index" */))
const _8a14591e = () => interopDefault(import('../pages/hermes-service/order.vue' /* webpackChunkName: "pages/hermes-service/order" */))
const _291b411e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2fa40542 = () => interopDefault(import('../pages/blog/article/_blog.vue' /* webpackChunkName: "pages/blog/article/_blog" */))
const _775f2de5 = () => interopDefault(import('../pages/blog/category/_category.vue' /* webpackChunkName: "pages/blog/category/_category" */))
const _964b226e = () => interopDefault(import('../pages/blog/tag/_tag.vue' /* webpackChunkName: "pages/blog/tag/_tag" */))
const _346ceedc = () => interopDefault(import('../pages/account/_tab.vue' /* webpackChunkName: "pages/account/_tab" */))
const _7e82236a = () => interopDefault(import('../pages/blog/_q.vue' /* webpackChunkName: "pages/blog/_q" */))
const _7d196e60 = () => interopDefault(import('../pages/cart/_step.vue' /* webpackChunkName: "pages/cart/_step" */))
const _817692e4 = () => interopDefault(import('../pages/categories/_category.vue' /* webpackChunkName: "pages/categories/_category" */))
const _77efbcf0 = () => interopDefault(import('../pages/category/_category.vue' /* webpackChunkName: "pages/category/_category" */))
const _c7d81c54 = () => interopDefault(import('../pages/cc/_ba/index.vue' /* webpackChunkName: "pages/cc/_ba/index" */))
const _cc3ef2de = () => interopDefault(import('../pages/f/_projection.vue' /* webpackChunkName: "pages/f/_projection" */))
const _8f9e5b1e = () => interopDefault(import('../pages/featured/_projection.vue' /* webpackChunkName: "pages/featured/_projection" */))
const _39ff5c64 = () => interopDefault(import('../pages/forget/_key.vue' /* webpackChunkName: "pages/forget/_key" */))
const _180da122 = () => interopDefault(import('../pages/item/_id.vue' /* webpackChunkName: "pages/item/_id" */))
const _4a1abad8 = () => interopDefault(import('../pages/list/_field.vue' /* webpackChunkName: "pages/list/_field" */))
const _2919d7bf = () => interopDefault(import('../pages/preview/_id.vue' /* webpackChunkName: "pages/preview/_id" */))
const _4464aa6a = () => interopDefault(import('../pages/random/_random1/index.vue' /* webpackChunkName: "pages/random/_random1/index" */))
const _06312ef6 = () => interopDefault(import('../pages/search/_q.vue' /* webpackChunkName: "pages/search/_q" */))
const _8014e750 = () => interopDefault(import('../pages/status/_status.vue' /* webpackChunkName: "pages/status/_status" */))
const _2bb15b4a = () => interopDefault(import('../pages/cc/_ba/_family/index.vue' /* webpackChunkName: "pages/cc/_ba/_family/index" */))
const _65bfc5ab = () => interopDefault(import('../pages/random/_random1/_random2/index.vue' /* webpackChunkName: "pages/random/_random1/_random2/index" */))
const _1585136a = () => interopDefault(import('../pages/random/_random1/_random2/_random3/index.vue' /* webpackChunkName: "pages/random/_random1/_random2/_random3/index" */))
const _bd34f31a = () => interopDefault(import('../components/core/catalogMap.vue' /* webpackChunkName: "components/core/catalogMap.vue" */))
const _e6e7a0e6 = () => interopDefault(import('../components/core/dynamicMap.vue' /* webpackChunkName: "components/core/dynamicMap.vue" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aboutUs",
    component: _ff341452,
    name: "aboutUs"
  }, {
    path: "/brands",
    component: _235bca30,
    name: "brands"
  }, {
    path: "/cc",
    component: _7d581f72,
    name: "cc"
  }, {
    path: "/contact",
    component: _40a0086c,
    name: "contact"
  }, {
    path: "/ds",
    component: _c55d451a,
    name: "ds"
  }, {
    path: "/favorites",
    component: _7faabe23,
    name: "favorites"
  }, {
    path: "/hermes",
    component: _085d660a,
    name: "hermes"
  }, {
    path: "/payments",
    component: _6d425811,
    name: "payments"
  }, {
    path: "/random",
    component: _866aba2c,
    name: "random"
  }, {
    path: "/search-results",
    component: _99e12a96,
    name: "search-results"
  }, {
    path: "/search-results-stage",
    component: _6ff81766,
    name: "search-results-stage"
  }, {
    path: "/shield",
    component: _0154ad4d,
    name: "shield"
  }, {
    path: "/shippings",
    component: _5755355e,
    name: "shippings"
  }, {
    path: "/success",
    component: _1ad10a62,
    name: "success"
  }, {
    path: "/terms",
    component: _59ce015a,
    name: "terms"
  }, {
    path: "/track",
    component: _f685b5d2,
    name: "track"
  }, {
    path: "/wizard",
    component: _cd335cdc,
    name: "wizard"
  }, {
    path: "/hermes-service/order",
    component: _8a14591e,
    name: "hermes-service-order"
  }, {
    path: "/",
    component: _291b411e,
    name: "index"
  }, {
    path: "/blog/article/:blog?",
    component: _2fa40542,
    name: "blog-article-blog"
  }, {
    path: "/blog/category/:category?",
    component: _775f2de5,
    name: "blog-category-category"
  }, {
    path: "/blog/tag/:tag?",
    component: _964b226e,
    name: "blog-tag-tag"
  }, {
    path: "/account/:tab?",
    component: _346ceedc,
    name: "account-tab"
  }, {
    path: "/blog/:q?",
    component: _7e82236a,
    name: "blog-q"
  }, {
    path: "/cart/:step?",
    component: _7d196e60,
    name: "cart-step"
  }, {
    path: "/categories/:category?",
    component: _817692e4,
    name: "categories-category"
  }, {
    path: "/category/:category?",
    component: _77efbcf0,
    name: "category-category"
  }, {
    path: "/cc/:ba",
    component: _c7d81c54,
    name: "cc-ba"
  }, {
    path: "/f/:projection?",
    component: _cc3ef2de,
    name: "f-projection"
  }, {
    path: "/featured/:projection?",
    component: _8f9e5b1e,
    name: "featured-projection"
  }, {
    path: "/forget/:key?",
    component: _39ff5c64,
    name: "forget-key"
  }, {
    path: "/item/:id?",
    component: _180da122,
    name: "item-id"
  }, {
    path: "/list/:field?",
    component: _4a1abad8,
    name: "list-field"
  }, {
    path: "/preview/:id?",
    component: _2919d7bf,
    name: "preview-id"
  }, {
    path: "/random/:random1",
    component: _4464aa6a,
    name: "random-random1"
  }, {
    path: "/search/:q?",
    component: _06312ef6,
    name: "search-q"
  }, {
    path: "/status/:status?",
    component: _8014e750,
    name: "status-status"
  }, {
    path: "/cc/:ba/:family",
    component: _2bb15b4a,
    name: "cc-ba-family"
  }, {
    path: "/random/:random1/:random2",
    component: _65bfc5ab,
    name: "random-random1-random2"
  }, {
    path: "/random/:random1/:random2/:random3",
    component: _1585136a,
    name: "random-random1-random2-random3"
  }, {
    path: "/c/:path*",
    component: _bd34f31a,
    name: "catalog-map"
  }, {
    path: "/d/:path*",
    component: _e6e7a0e6,
    name: "dynamic-map"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
